import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const calendarTradeBookingsQueryAtom = createQueryAtomFactory(
  'calendar.tradeBookings',
  (params: { fromDate: string; toDate: string }) => ({
    bookings: {
      __args: {
        filter: {
          fromCutOffDate: params.fromDate,
          toCutOffDate: params.toDate,
        },
        pagination: {
          limit: 500,
          offset: 0,
        },
      },
      entries: {
        id: true,
        documentNumber: true,
        status: true,
        cutOffDate: true,
        vesselDepartureDate: true,
      },
      page: {
        total: true,
      },
    },
  }),
);
